import React from 'react';
import './sec2-home.css'
import { supabase } from '../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import pic15 from '../assets/pic15.png'

const Sec2home = () => {




 const [content, setcontent]= useState([]);
      useEffect(() => {
      const getcontent = async()=>{
          const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;;
    
      setcontent(res.data);
      }
      getcontent();
      }, []);

  const [Exhibitors, setExhibitors]= useState([]);



useEffect(() => {
  const getExhibitors = async () => {
    const { data, error } = await supabase
      .from('exhibitors')
      .select(`
        id,
        image,
        img_alt,
        exhibitor_name,
        exbition_event_exhibitors!inner (
          event_exhibitors_id
        )
      `)
      .eq('exbition_event_exhibitors.event_exhibitors_id', 1)
      .limit(3)
      .order('id', { ascending: true });

    if (error) {
      console.log(error);
      setExhibitors([]);
      return;
    }

    setExhibitors(data || []);
  };

  getExhibitors();
}, []);









const sliderRef = React.useRef(null);
const isDown = React.useRef(false);
    const startX = React.useRef(0);
const scrollLeft = React.useRef(0);
    const handleMouseDown = (e) => {
    isDown.current = true;
    startX.current = e.pageX - sliderRef.current.offsetLeft;
    scrollLeft.current = sliderRef.current.scrollLeft;
    };

const handleMouseLeave = () => { isDown.current = false; };
const handleMouseUp = () => { isDown.current = false; };

const handleMouseMove = (e) => {
  if (!isDown.current) return;
  e.preventDefault();
  const x = e.pageX - sliderRef.current.offsetLeft;
  const walk = (x - startX.current) * 1.5;
  sliderRef.current.scrollLeft = scrollLeft.current - walk;
};

const navigate = useNavigate();
    return ( 
        <section className='sec2-home'>
                <h1 className='header-section'>{content?.[25]?.header}</h1>
                <section className="slider-outer">
                <section className="slider-scroll"
                  ref={sliderRef}
                onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseLeave}
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}>
                <figure className='container-imgs-sec2-home'
               >
                {Exhibitors?.slice(0, 3).map((item, index) => (
                <figure
                    key={item.id}
                    className='big-container-imgs-sec2-home'
                    onClick={index === 0 ? () => navigate('/error') : undefined}
                    style={{ cursor: index === 0 ? 'pointer' : 'default' }}
                >
                          <button   className='circle-cta-home'>
                          <img className='arrroww' src={pic15} alt='view more details'></img>
                      </button>
                    <img
                    className='imgs-sec2-home'
                    src={item.image}
                    alt={item.img_alt}
                    />
                </figure>
                
                ))}
                </figure>
                </section>
                </section>
        </section>
     );
}
 
export default Sec2home;